import { createTestIds } from '@duke-hq/lib';

export const testIds = createTestIds('apps-admin-web-Providers-ProvidersPage', [
  'heading',
  'openCreateProviderModal',
]);
